import { ViewerComponent } from "./Landing";

const GeneralProvisions = () => {
    return   <div style={{ marginTop: 0, backgroundColor: '#fff', paddingTop: '20px', height: '100vh', borderRadius: '10px' }}>
        <div style={{display: 'flex', justifyContent: 'center', fontWeight: 600, marginBottom: 10}}><span>Quy định chung</span></div>
          <ViewerComponent fileUrl={'pdf/quy-dinh-chung.pdf'} />
     </div>
}

export default GeneralProvisions;